import { twMerge } from 'tailwind-merge';

/**
 * Tailwind CSS 클래스를 병합하는 유틸리티 함수
 * 중복되는 클래스가 있을 경우 뒤에 오는 클래스가 우선순위를 갖습니다.
 *
 * @param  {...string} classes - 병합할 클래스 문자열들
 * @returns {string} 병합된 클래스 문자열
 *
 * @example
 * cn('px-4 py-2 bg-blue-500', 'bg-red-500')
 * // 결과: 'px-4 py-2 bg-red-500'
 */
export function cn(...classes) {
  return twMerge(...classes);
}

export default cn;
